import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelefoneMaskDirective } from './telefone-mask.directive';
import { CepMaskDirective } from './cep-mask.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [CepMaskDirective, TelefoneMaskDirective],
  exports: [CepMaskDirective, TelefoneMaskDirective]
})
export class DirectivesModule { }
